import {
    RichTableColumns,
} from 'app/types/richtable.types'

import {
    CustomerTransportTableType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const columns = ({
    l,
}: {
    l: (l: string) => string
}): RichTableColumns<keyof CustomerTransportTableType>[] => {
    return [
        {
            id: 'orderNumber',
            headerProps: {
                children: l('DailyOpsView.orderNumber'),
            },
            componentName: 'OrderTableLink',
            mapCellProps: 'orderNumber',
        },
        {
            id: 'from',
            headerProps: {
                children: l('DailyOpsView.from'),
            },
            mapCellProps: 'from',
        },
        {
            id: 'to',
            headerProps: {
                children: l('DailyOpsView.to'),
            },
            mapCellProps: 'to',
        },
        {
            id: 'destinationCountry',
            headerProps: {
                children: l('OrderView.destinationCountry'),
            },
            mapCellProps: 'destinationCountry',
        },
        {
            id: 'destinationLocationLocationName',
            headerProps: {
                children: l('DailyOpsView.destinationLocationLocationName'),
            },
            mapCellProps: 'destinationLocationLocationName',
        },
        {
            id: 'originLocationLocationName',
            headerProps: {
                children: l('DailyOpsView.originLocationLocationName'),
            },
            mapCellProps: 'originLocationLocationName',
        },
        {
            id: 'requestedHandover',
            headerProps: {
                children: l('DailyOpsView.requestedHandover'),
            },
            mapCellProps: 'requestedHandover',
        },
        {
            id: 'forwarderLocationName',
            headerProps: {
                children: l('Order.forwarderExport'),
            },
            mapCellProps: 'forwarderLocationName',
        },
    ]
}

export default columns
